module.exports = __webpack_public_path__ + "static/media/sunny.d47b42ff.jpg";